import { getTranslation } from 'utils/translation';
import { NavMenuProps, NavSubMenuProps } from './const';
import { ROUTES } from 'router/const';
import { Icon } from 'components/icon/Icon';
import { Logos } from 'contents/logos';
import { FEATURES } from './feature/const';

export const CONSTANTS = {
  get NAV_MENU(): NavMenuProps[] {
    return [
      { key: '', title: '', path: '/', icon: <Logos.symbolLogo /> },
      {
        key: 'library',
        title: getTranslation('resource', 'LIBRARY').toUpperCase(),
        path: ROUTES.LIBRARY.PATH,
        icon: <Icon icon="Folder" size={20} stroke="--text-gray-normal" />,
        children: [
          {
            key: 'datasets',
            title: getTranslation('resource', 'DATASETS'),
            path: ROUTES.LIBRARY.DATASETS.PATH,
          },
          {
            key: 'data-sources',
            title: getTranslation('resource', 'DATASOURCES'),
            path: ROUTES.LIBRARY.DATASOURCES.PATH,
          },
          {
            key: 'logs',
            title: getTranslation('resource', 'EXPORT_LOGS'),
            path: ROUTES.LIBRARY.LOGS.PATH,
          },
        ].filter(Boolean) as NavSubMenuProps[],
      },
      {
        key: 'project',
        title: getTranslation('resource', 'PROJECT').toUpperCase(),
        icon: <Icon icon="Database01" size={20} stroke="--text-gray-normal" />,
        path: ROUTES.PROJECT.PATH,
        children: [
          {
            key: 'list',
            title: getTranslation('resource', 'PROJECTS'),
            path: ROUTES.PROJECT.LIST.PATH,
          },
        ],
      },
      {
        key: 'flow',
        title: getTranslation('resource', 'FLOW').toUpperCase(),
        icon: <Icon icon="Dataflow01" size={20} stroke="--text-gray-normal" />,
        path: ROUTES.FLOW.PATH,
        children: [
          {
            key: 'flows',
            title: getTranslation('resource', 'APF'),
            path: ROUTES.FLOW.FLOWS.PATH,
          },
          ...(FEATURES.APF_GROUP_MODE
            ? [
                {
                  key: 'groups',
                  title: getTranslation('resource', 'GROUPS'),
                  path: ROUTES.FLOW.GROUPS.PATH,
                },
              ]
            : []),
          ...(FEATURES.S_CORE_MODE
            ? [
                {
                  key: 'logs',
                  title: getTranslation('resource', 'FLOW_LOGS'),
                  path: ROUTES.FLOW.LOGS.PATH,
                },
              ]
            : []),
        ],
      },

      ...(FEATURES.REPORT_VIEW
        ? [
            {
              key: 'report',
              title: getTranslation('resource', 'REPORT').toUpperCase(),
              icon: <Icon icon="BarChart12" size={20} stroke="--text-gray-normal" />,
              path: ROUTES.REPORT.PATH,
              children: [
                {
                  key: 'drafts',
                  title: getTranslation('resource', 'DRAFTS'),
                  path: ROUTES.REPORT.DRAFT_LIST.PATH,
                },
                {
                  key: 'connections',
                  title: getTranslation('resource', 'CONNECTIONS'),
                  path: ROUTES.REPORT.CONNECTION_LIST.PATH,
                },
                {
                  key: 'publish',
                  title: getTranslation('resource', 'PUBLISH'),
                  path: ROUTES.REPORT.PUBLISH_LIST.PATH,
                },
              ],
            },
          ]
        : []),
      {
        key: 'admin',
        title: getTranslation('resource', 'ADMIN').toUpperCase(),
        icon: <Icon icon="Users02" size={20} stroke="--text-gray-normal" />,
        path: ROUTES.ADMIN.PATH,
        children: [
          {
            key: 'users',
            title: getTranslation('resource', 'USERS'),
            path: ROUTES.ADMIN.USERS.PATH,
          },
          {
            key: 'groups',
            title: getTranslation('resource', 'GROUPS'),
            path: ROUTES.ADMIN.GROUPS.PATH,
          },
          {
            key: 'roles',
            title: getTranslation('resource', 'ROLES'),
            path: ROUTES.ADMIN.ROLES.PATH,
          },
          {
            key: 'connectors',
            title: getTranslation('resource', 'CONNECTORS'),
            path: ROUTES.ADMIN.CONNECTORS.PATH,
          },
          {
            key: 'domains',
            title: getTranslation('resource', 'DOMAINS'),
            path: ROUTES.ADMIN.DOMAINS.PATH,
          },
          {
            key: 'userLogs',
            title: getTranslation('resource', 'USER_LOGS'),
            path: ROUTES.ADMIN.USER_LOGS.PATH,
          },
        ],
      },

      ...(FEATURES.MANAGEMENT_MODE
        ? [
            {
              key: 'external',
              title: getTranslation('resource', 'EXTERNAL'),
              icon: <Icon icon="LinkExternal01" size={20} stroke="--text-gray-normal" />,
              path: ROUTES.EXTERNAL.PATH,
              children: [
                {
                  key: 'jupyter',
                  title: getTranslation('resource', 'JUPYTER'),
                  path: ROUTES.EXTERNAL.JUPYTER.PATH,
                },
              ],
            },
          ]
        : []),
    ];
  },

  get S_CORE_NAV_MENU(): NavMenuProps[] {
    return [
      { key: '', title: '', path: '/', icon: <Logos.symbolLogo /> },
      {
        key: 'library',
        title: getTranslation('resource', 'WAREHOUSE'),
        path: ROUTES.LIBRARY.PATH,
        icon: <Icon icon="Databases04" size={20} stroke="--text-gray-normal" />,
        children: [
          {
            key: 'datasets',
            title: getTranslation('resource', 'WAREHOUSE'),
            path: ROUTES.LIBRARY.DATASETS.PATH,
          },
          {
            key: 'data-sources',
            title: getTranslation('resource', 'DATASOURCES'),
            path: ROUTES.LIBRARY.DATASOURCES.PATH,
          },
        ].filter(Boolean) as NavSubMenuProps[],
      },
      {
        key: 'mart',
        title: getTranslation('resource', 'MART'),
        path: ROUTES.MART.PATH,
        icon: <Icon icon="Database01" size={20} stroke="--text-gray-normal" />,
        children: [
          {
            key: 'answersets',
            title: getTranslation('resource', 'MART'),
            path: ROUTES.MART.ANSWERSET.PATH,
          },
          {
            key: 'logs',
            title: getTranslation('resource', 'EXPORT_LOGS'),
            path: ROUTES.MART.LOGS.PATH,
          },
        ].filter(Boolean) as NavSubMenuProps[],
      },
      {
        key: 'project',
        title: getTranslation('resource', 'WORKSPACE'),
        icon: <Icon icon="Dataflow01" size={20} stroke="--text-gray-normal" />,
        path: ROUTES.PROJECT.PATH,
        children: [
          {
            key: 'list',
            title: getTranslation('resource', 'STUDIO'),
            path: ROUTES.PROJECT.LIST.PATH,
          },
          ...(FEATURES.MANAGEMENT_MODE
            ? [
                {
                  key: 'jupyter',
                  title: getTranslation('resource', 'JUPYTER'),
                  path: ROUTES.PROJECT.JUPYTER.PATH,
                },
              ]
            : []),
        ],
      },
      {
        key: 'flow',
        title: getTranslation('resource', 'MONITOR'),
        icon: <Icon icon="Dataflow03" size={20} stroke="--text-gray-normal" />,
        path: ROUTES.FLOW.PATH,
        children: [
          {
            key: 'flows',
            title: getTranslation('resource', 'JOB_MONITORING'),
            path: ROUTES.FLOW.FLOWS.PATH,
          },
          ...(FEATURES.APF_GROUP_MODE
            ? [
                {
                  key: 'groups',
                  title: getTranslation('resource', 'GROUPS'),
                  path: ROUTES.FLOW.GROUPS.PATH,
                },
              ]
            : []),
          ...(FEATURES.S_CORE_MODE
            ? [
                {
                  key: 'logs',
                  title: getTranslation('resource', 'LOGS'),
                  path: ROUTES.FLOW.LOGS.PATH,
                },
              ]
            : []),
        ],
      },
      {
        key: 'admin',
        title: getTranslation('resource', 'MANAGEMENT'),
        icon: <Icon icon="Users02" size={20} stroke="--text-gray-normal" />,
        path: ROUTES.ADMIN.PATH,
        children: [
          {
            key: 'users',
            title: getTranslation('resource', 'USERS'),
            path: ROUTES.ADMIN.USERS.PATH,
          },
          {
            key: 'groups',
            title: getTranslation('resource', 'GROUPS'),
            path: ROUTES.ADMIN.GROUPS.PATH,
          },
          {
            key: 'roles',
            title: getTranslation('resource', 'ROLES'),
            path: ROUTES.ADMIN.ROLES.PATH,
          },
          {
            key: 'connectors',
            title: getTranslation('resource', 'CONNECTORS'),
            path: ROUTES.ADMIN.CONNECTORS.PATH,
          },
          {
            key: 'domains',
            title: getTranslation('resource', 'DOMAINS'),
            path: ROUTES.ADMIN.DOMAINS.PATH,
          },
          {
            key: 'userLogs',
            title: getTranslation('resource', 'USER_LOGS'),
            path: ROUTES.ADMIN.USER_LOGS.PATH,
          },
        ],
      },
    ];
  },
} as const;
